export const BuildAddress = (obj) => {
  const parts = [];
  const fields = ["buildingName", "buildingNumber", "line1", "line2", "line3", "line4", "postcode"];
  for (const field of fields) if (obj[field]) parts.push(obj[field]);
  return parts.join(", ");
};
